
class Paging {
	
	constructor(pagingOptions) {
		this.itemPerPage = 10;
		this.totalPage = (pagingOptions.totalPage < this.itemPerPage) ? pagingOptions.totalPage : this.itemPerPage;
		this.initialPage = pagingOptions.initialPage;
		this.location = pagingOptions.location;
		this.url = pagingOptions.url;
		this.o = pagingOptions.o;
		this.defaultOrder = pagingOptions.defaultOrder;
	}

	createButton(index, value) {
		let button = document.createElement('a');
		button.classList.add('checklist__item');
		button.textContent = index;
		button.dataset.value = value;

		let hash = '';
		if (value != 1) {
			hash += 'p='+value;
		}
		if (this.o != this.defaultOrder) {
			if (hash) {
				hash += '&';
			}
			hash += 'o='+this.o;
		}

		button.href = this.url + (hash ? '?'+hash : '');
		
		if (this.initialPage == index) {
			button.classList.add('checklist__item--active');
		}

		return button;
	}

	createPagination() {
		this.location.innerHTML = '';

		if (this.initialPage != 1) {
			this.location.append(this.createButton('<', (this.initialPage-1) ));
		}

		for (let i=0; i<this.totalPage; i++) {
			this.location.append(this.createButton( (i+1), (i+1) ));
		}

		if (this.initialPage != this.totalPage) {
			this.location.append(this.createButton('>', (parseInt(this.initialPage)+1) ));
		}
	}
}

function sendHintSearchList(href) {
	// Счетчик яндекса
	if (typeof ym !== "undefined") {
		ym(18881956, 'hit', window.location, {
			params: {
				title: 'Смена фото',
				target: href
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', function(){
	
	const sortEl = document.querySelector('select[name="o"]'),
				pageEl = document.querySelector('input[name="page"]'),
				form = document.forms.searchForm,
				searchList = document.querySelector('.search-list__list'),
				citySelect = document.querySelector('.slp-form__field--city .picker__select'),
				_h1 = document.querySelector('.search-list__header'),
				perelinksList = document.querySelector('.perelinks__list'),
				mapLinks = document.querySelectorAll('.search-result-header__map, .h__sl-toolbar-item--map'),
				itemsCountEl = document.querySelector('.search-result-header__count span'),
				extendedFormLink = document.querySelector('.slp-form__extended-form-link'),
				
				searchPanel = document.querySelector('.slp-form'),
				// openSearchPanelBtn = document.querySelector('.h__sl-toolbar-item'),
				// closeSearchPanelBtn = document.querySelector('.slp-form__close-btn'),
				
				seoText = document.querySelector('.about-text--seo'),
				//
				// if ajaxUpdate then search-list updates by ajax on page or order change
				// else we need to give a ststic page and page or order change will reload the page
				ajaxUpdate = searchList.hasAttribute('data-items');

	let searchPanelOffset;
	
	if (ajaxUpdate) {
		var defaultOrder = form.dataset.defaultO,
			searchListUrl = searchList.dataset.items,
			searchListLocation = searchListUrl.substr(0, searchListUrl.indexOf('?')),
			searchListHash = searchListUrl.substr(searchListUrl.indexOf('?')+1),
			ajaxSearchData = JSON.parse('{"' + decodeURI(searchListHash).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

			if (!ajaxSearchData.hasOwnProperty('o')) {
				ajaxSearchData.o = 0;
			}
			if (!ajaxSearchData.hasOwnProperty('page')) {
				ajaxSearchData.page = 1;
			}
	}
	

	// 
	// sliders for search result list
	function slidersInit() {
		let srlSliders = document.querySelectorAll('.sri__slider-wrp');
		srlSliders.forEach(function(slider){
			new Swiper(slider, {
				// preloadImages: false,
				// lazy: true,
				navigation : {
					nextEl: slider.querySelector('.sri__slider-btn--next'),
					prevEl: slider.querySelector('.sri__slider-btn--prev'),
					disabledClass: 'sri__slider-btn--disabled'
				},
				on: {
					slideChange: function () {
						slider.querySelector('[data-current-index]').textContent = this.realIndex + 1;
						const href = slider.querySelector('.sri__slider').href;
						sendHintSearchList(href);
					}
				}
			});
		});
	}


	function renderCard(card, cardIndex) {
		let photos = '';
		card.photos.forEach(function(photo, photoIndex){
			photos += `
				<div class="sri__slide swiper-slide">
					<img class="sri__slide-image" 
						${!cardIndex && !photoIndex ? 'fetchPriority="high"' : 'loading="lazy" decoding="async"'}
						src="${photo}"
					/>
				</div>
			`;
		});

		let areas = '';
		card.areas.forEach(function(area){
			areas += `<a class="sri__area-link link link--grey" href="${area.link}">${area.name}</a>, `;
		});
		if (areas.length) {
			let index = areas.lastIndexOf(",");
			areas = areas.substring(0, index) + areas.substring(index+1);
		}

		let techs = '';
		card.techs.forEach(function(tech){
			techs += `
				<li class="sri__tech-item">${tech}</li>
			`;
		});

		let complex = '';
		if (card.complex) {
			// complex += `<p class="sri__complex">${card.complex.count} объявления в <a class="link" href="${card.complex.link}" target="_blank">${card.complex.name}</a></p>`;
			complex += `<p class="sri__complex"><a class="link" href="${card.complex.link}" target="_blank">${card.complex.name}</a></p>`;
		}

		let proHtml = '';
		if (card.hasOwnProperty('seller') && card.seller.hasOwnProperty('pro')) {

			let provalHtml = '';
			if (card.seller.proValue) {
				provalHtml = `<p class="sri__pro-value">${card.seller.proValue}</p>`;
			}

			proHtml = `
				<div class="sri__pro">
					<p class="sri__pro-label">PRO</p>
					${provalHtml}
				</div>
			`;
		}

		let contacts = '';
		if (card.itemType == 'archived') {
			// contacts = `
			// 	<div class="sri__contacts sri__contacts--archived">
			// 		<p class="sri__warning-archive"> 
			// 			<svg>
			// 				<use xlink:href="/img/icons.svg#warning"></use>
			// 			</svg><span>Объявление в архиве</span>
			// 		</p><a class="sri__call btn btn--blue" href="${card.link}" target="_blank">Купить контакты</a>
			// 	</div>`;
		} else {
			let contactsInner = `
				<div class="sri__avatar-wrp">
					<img class="sri__avatar" src="${card.seller.photo}" loading="lazy" decoding="async"/>
				</div>
				<p class="sri__contact-name">${card.seller.name}</p>
				${card.seller.type ? '<p class="sri__type">'+card.seller.type+'</p>' : ''}
				${proHtml}
			`;

			if (card.seller.link) {
				contactsInner = `<a class="sri__company-link" href="${card.seller.link}">${contactsInner}</a>`;
			}

			contacts = `
				<div class="sri__contacts">
					${contactsInner}
					<button class="sri__call btn btn--blue">Показать телефон</button>
				</div>`;
		}

		let cardHtml = document.createElement('div');
		cardHtml.classList.add('sri');
		if (card.itemType == 'premium') {
			cardHtml.classList.add('sri--yellow', 'sri--premium');
		}
		if (card.itemType == 'topPro') {
			cardHtml.classList.add('sri--premium');
		}
		
		if (card.itemType == 'pro') {
			cardHtml.classList.add('sri--pro');
		}

		if (card.itemType == 'archived') {
			cardHtml.classList.add('sri--archived');
		}

		let priceHtml = '';
		if (card.priceNew) {
			priceHtml = `
				<div class="sri__price-wrp sri__price-wrp--changed">
					<p class="sri__price">${card.price}</p>
					<p class="sri__price-new">${card.priceNew}</p>
				</div>`;
		} else {
			priceHtml = `
				<div class="sri__price-wrp">
					<p class="sri__price">${card.price}</p>
				</div>`;
		}

		let mortage = '';
		if (card.mortageLink && card.mortageLink.length) {
			mortage = `<noindex><a class="sri__mortage link" href="${card.mortageLink}" rel="nofollow">Купить в ипотеку</a></noindex>`;
		} else {
			mortage = `<div class="sri__mortage"></div>`;
		}

		let moreAds = '';
		if (card.moreAds) {
			moreAds = `
				<div class="sri__more-ads">
					<a class="link" href="${card.moreAds.link}">${card.moreAds.text}</a>
				</div>
			`;
		}

		let toolbarBtnsHtml = '';
		if (card.itemType != 'archived') {

			let favHtml = '';
			if (g.favourites.indexOf(card.link) != -1) {
				favHtml = `
					<a class="icon-btn icon-btn--fav active" href="//www.restate.ru/user/bookmarks/" target="_blank" aria-label="Избранное"
						data-add-to-fav data-id="${card.link}" data-title="${card.header}">
						<i class="icon-btn__icon"></i><span class="icon-btn__name" data-success="В избранное">В избранном</span>
					</a>`;
			} else {
				favHtml =`
					<a class="icon-btn icon-btn--fav" href="//www.restate.ru/user/bookmarks/" target="_blank" aria-label="Избранное"
						data-add-to-fav data-id="${card.link}" data-title="${card.header}">
						<i class="icon-btn__icon"></i><span class="icon-btn__name" data-success="В избранном">В избранное</span>
					</a>`;		
			}

			let compareHtml = '';
			if (g.compares.indexOf(card.compare.fromRegion+'-'+card.compare.type+'-'+card.compare.id) != -1) {
				compareHtml = `
					<a class="icon-btn icon-btn--compare active" href="//www.restate.ru/compare/" target="_blank" aria-label="Сравнить"
						data-add-to-compare data-id="${card.compare.id}" data-type="${card.compare.type}" data-freg="${card.compare.fromRegion}">
						<i class="icon-btn__icon"></i><span class="icon-btn__name" data-success="В сравнение">В сравнении</span>
					</a>`;
			} else {
				compareHtml = `
					<a class="icon-btn icon-btn--compare" href="//www.restate.ru/compare/" target="_blank" aria-label="Сравнить"
						data-add-to-compare data-id="${card.compare.id}" data-type="${card.compare.type}" data-freg="${card.compare.fromRegion}">
						<i class="icon-btn__icon"></i><span class="icon-btn__name" data-success="В сравнении">В сравнение</span>
					</a>`;		
			}

			toolbarBtnsHtml = `
				<div class="sri__icon-btns">
					<a class="icon-btn icon-btn--write" aria-label="Написать автору"
						data-popup-target="popup--send-msg"
						data-input-values='{"ad-id": "${card.uid}"}'>
						<i class="icon-btn__icon"></i><span class="icon-btn__name">Написать</span>
					</a>
					${favHtml}
					${compareHtml}`;
		}
		
		cardHtml.uid = card.uid;
		cardHtml.innerHTML = `
			<div class="sri__inner">
				<noindex>
					<div class="sri__slider-wrp swiper-container">
						<a class="sri__slider swiper-wrapper"
							href="${card.link}" target="_blank"
							aria-label="${card.header}"
						>
							${photos}
						</a>
						<button class="sri__slider-btn sri__slider-btn--prev" aria-label="Предыдущее фото"></button>
						<button class="sri__slider-btn sri__slider-btn--next" aria-label="Следующее фото"></button>
						<p class="sri__count"><span data-current-index="data-current-index">1</span>из ${card.photos.length}</p>
					</div>
				</noindex>
				<div class="sri__content-wrp">
					<a class="sri__common-link" href="${card.link}" target="_blank" aria-label="${card.header}"></a>
					<div class="sri__content">
						<div class="sri__descr">
							<p class="sri__header link">${card.header}
								${(card.itemType == 'premium') ? '<label>Премиум</label>' : ''}
								${(card.itemType == 'pro') ? '<label>PRO</label>' : ''}
							</p>
							<div class="sri__price-block">
								${priceHtml}
								<p class="sri__price-quality">${card.priceQuality}</p>
								${mortage}
							</div>
							<div class="sri__area-wrp">
								<div class="sri__area">${areas}</div>
								<div class="sri__route">${card.metro}${card.route}</div>
							</div>
							<div class="sri__descr-wrp">
								<ul class="sri__tech">${techs}</ul>
								<div class="sri__descr-text">${card.descr}</div>
								${(card.descrPc && card.descrPc.length) ? '<div class="sri__descr-text sri__descr-text--pc">' + card.descrPc + '</div>' : ''}
								${complex}
							</div>
						</div>
						${contacts}
					</div>
					<div class="sri__toolbar">
						<div class="sri__toolbar-inner">
							<p class="sri__watched eye-counter">${card.views}</p>
							<p class="sri__date">${card.date}</p>
							${toolbarBtnsHtml}
							</div>
						</div>
						${moreAds}
					</div>
					${(card.itemType != 'archived') ? '<div class="sri__xs-toolbar"><a class="sri__call sri__call--xs">Позвонить</a></div>' : '' }
				</div>
			</div>
		`;

		searchList.append(cardHtml);
	}


	function renderMeta(data) {

		if (data.h1) {
			_h1.textContent = data.h1;
		}
		
		if (data.url && (window.location.hostname.indexOf('restate.ru') != -1) ) {
			window.history.pushState({}, "", data.url);
			document.querySelector('.subscr__wrp').dataset.id = data.url;
		}

		data.meta.forEach(function(meta){
			document.querySelector('meta[name="'+meta.name+'"]').setAttribute('content', meta.value);
			if (meta.name == 'title') {
				document.title = meta.value;
			}
		});


		if (data.perelinks.length) {
			perelinksList.innerHTML = '';

			data.perelinks.forEach(function(link){
				let linkLi = document.createElement('li');
				linkLi.classList.add('perelinks__item');

				let linkEl = document.createElement('a');
				linkEl.classList.add('perelinks__link', 'link');
				linkEl.setAttribute('href', link.href);
				linkEl.textContent = link.name;
				linkLi.append(linkEl);

				perelinksList.append(linkLi);
			});
		}

		if (data.mapLink) {
			mapLinks.forEach(function(link){
				link.setAttribute('href', data.mapLink);
			})
		}

		if (data.pageCount) {
			drawPagination(data.pageCount);
		}

		if (data.itemsCount) {
			itemsCountEl.textContent = data.itemsCount;
		}

		if (data.seoText) {
			seoText.innerHTML = data.seoText;
		}
	}

	function scrollToSearchListBeginning() {
		window.scrollTo({top: 0, behavior: 'smooth'});
	}

	// 
	// fixing search panel
	if(searchPanel) {
		window.addEventListener('resize', function(){
			searchPanelOffset = searchPanel.offsetTop;
		});
		searchPanelOffset = searchPanel.offsetTop;
	
		window.addEventListener('scroll', function(){		
			if (window.pageYOffset > searchPanelOffset) {
				searchPanel.classList.add('slp-form--fixed');
			} else {
				searchPanel.classList.remove('slp-form--fixed');
			}
		});
	}


	function drawPagination(pageCount) {

		const pagingOptions = {
			totalPage: pageCount,
			initialPage: ajaxSearchData.page,
			location: document.querySelector('[data-paging] .checklist__list'),
			url : ajaxSearchData.url,
			o: ajaxSearchData.o,
			defaultOrder: defaultOrder 
		};
	
		let paging = new Paging(pagingOptions);
		paging.createPagination();
	}

	function updatePage() {
		// let query = new URLSearchParams(ajaxSearchData);
		
		let query = '';
		for (let key in ajaxSearchData) {
			
			if ( (key == 'o') && (ajaxSearchData[key] == defaultOrder) ) {
				continue;
			}

			if ( (key == 'page') && parseInt(ajaxSearchData[key]) == 1 ) {
				continue;
			}

			query += key + '='+ ajaxSearchData[key] + '&';
		}
		// query = query.slice(0, -1);
		query += 'w='+ (window.innerWidth < 1020 ? 'xs' : 'xl');
		
		closeSearchPanel();

		searchList.classList.add('search-list__list--loading');

		fetch(searchListLocation + '?' + query, {
			method: 'post',
			credentials: 'include'
			// body: query
		}).then(response => {
			return response.json();
		}).then(resp => {
			renderMeta(resp.additional);
			renderSearchList(resp.items);
		});

		scrollToSearchListBeginning();
	}


	function renderSearchList(items) {
		
		searchList.innerHTML = '';
		items.forEach(function(item, index){
			if (item.type == "item") {
				renderCard(item, index);
			}
			if (item.type == "ad") {
				searchList.insertAdjacentHTML('beforeend', item.html);
			}
		});

		slidersInit();
		let newPickers = searchList.querySelectorAll('.picker');
		if (newPickers.length) {
			newPickers.forEach(picker => {
				pickerObj.createPicker(picker);
			});
		}
		searchList.classList.remove('search-list__list--loading');
		g.dynamicRendered = true;
	}

	function closeSearchPanel() {
		searchPanel.classList.remove('slp-form--active');
		document.body.style.overflow = '';
	}

	// 
	// submitting search form
	// form.addEventListener('submit', function(e){
	// 	e.preventDefault();
		
	// 	updatePage();
	// });

	// change page
	if (pageEl) {
		pageEl.addEventListener('change', function(){

			ajaxSearchData.page = pageEl.value;
			updatePage();

			if (ajaxSearchData.page != 1) {
				seoText.style.display = 'none';
			} else {
				seoText.style.display = '';
			}
		});
	}

	// change sort
	if(sortEl) {
		sortEl.addEventListener('change', function(){
	
			if (ajaxUpdate) {
				ajaxSearchData.o = sortEl.value;
				ajaxSearchData.page = 1;
	
				updatePage();	
			} else {
	
				let search = window.location.search.substring(1),
						searchObject = new URLSearchParams(search);
				
				if (searchObject.has('o')) {
					searchObject.set('o', sortEl.value);
				} else {
					searchObject.append('o', sortEl.value);
				}
	
				if (searchObject.has('page')) {
					searchObject.delete('page');
				}
	
				if (searchObject.has('viewport')) {
					searchObject.set('viewport', window.innerWidth < 1020 ? 'xs' : 'xl');
				} else {
					searchObject.append('viewport', window.innerWidth < 1020 ? 'xs' : 'xl');
				}
	
				window.location = window.location.origin + window.location.pathname + '?' + searchObject.toString();
			}
		});
	}


	//
	//  show tels
	document.addEventListener('click', function(e){
		let btn = e.target.closest('.sri__call');
		if (btn && !btn.hasAttribute('href')) {
			e.preventDefault();

			let sri = btn.closest('.sri'),
					data = {id: sri.uid ? sri.uid : sri.dataset.id, n: 1},
					telEls = sri.querySelectorAll('.sri__call');

			btn.classList.add('sri__call--loading');
			btn.disabled = true;

			fetch('/show_contacts/', {
				method: 'post',
				body: JSON.stringify(data),
				credentials: 'include',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
				}
			}).then(response => {
				return response.json();
			}).then(resp => {

				telEls.forEach(function(tel){
					tel.textContent = resp.tel;
					tel.setAttribute('href', 'tel:'+resp.tel);
					
					if (window.innerWidth < 768){
						window.location = 'tel:'+resp.tel;
					}
				});

			}).finally(() => {
				btn.classList.remove('sri__call--loading');
				btn.disabled = false;
			});
		}
	});


	// city change
	// if (citySelect) {
	// 	citySelect.addEventListener('change', function(){
	// 		form.setAttribute('action', this.options[this.selectedIndex].dataset.action);
	// 	});
	// }

	slidersInit();
	
	if (ajaxUpdate) {
		updatePage();
	}
});

const slpForm = document.querySelector('.slp-form');
if (slpForm) {
	let dealidValue = document.querySelector('.picker__select--dealid').value,
			priceTypeDefault = (dealidValue == 2) ? 
				document.querySelector('.slp-form__select--square-type .picker__select--buy').value
				: document.querySelector('.slp-form__select--square-type .picker__select--rent').value,
			defaultType = document.querySelector('.slp-form__field--type select'),
			defaultTypeValue = defaultType.options[defaultType.selectedIndex].dataset.type;
	
	const searchForm = {
		data() {
			return {
				isBigFormActive: false,
				dealid: dealidValue,
				type: defaultTypeValue,
				priceType: priceTypeDefault,
				mobile: window.innerWidth < 768,
				typeEl: null
			}
		},
		mounted() {
			this.initPriceInput();
			this.initRegions();

			this.typeEl = this.$refs.typeEl ? this.$refs.typeEl : document.querySelector('.slp-form__field--type select');
		},
		created() {
			window.addEventListener('resize', this.handleResize);
		},
		unmounted() {
			window.removeEventListener('resize', this.handleResize);
		},
		watch: {
			'type': function(newType, oldType) {
				if ( (newType == 'land') || (oldType == 'land') ) {
					this.priceType = 1;
					this.updatePriceType();
				}
			},
			'dealid': function() {
				this.priceType = 1;
				this.updatePriceType();
			},
			'priceType': function() {
				this.initPriceInput();
			},
		},
		methods: {
			initPriceInput() {
				this.$nextTick(function () {
					if (this.$refs.priceText) {
						IMask(this.$refs.priceText, {
							mask: Number,
							signed: false,
							thousandsSeparator: ' ',
						});
					}
				});
			},
			initRegions() {
				fetch('https://www.restate.ru/siteforms/getcities/', {
					method: 'get'
				}).then(response => {
					return response.json();
				}).then(res => {
					this.drawRegions(res.regions)
				}).catch(function(error) {
					console.error(error);
				});
			},
			drawRegions(regions) {

				const picker = this.$refs.regionEl,
					select = picker.querySelector('select');

				regions.forEach(function(region){

					const opt = document.createElement('option');
					opt.value = region.id;
					opt.textContent = region.name;
					opt.setAttribute('data-action', region.action);
					opt.setAttribute('data-header-link', '');
					select.appendChild(opt);
					
					region.items.forEach(function(subreg){

						const opt = document.createElement('option');
						opt.value = subreg.id;
						opt.textContent = subreg.name;
						opt.setAttribute('data-action', subreg.action);
						select.appendChild(opt);
					})
				});

				select.initialRegionChange = true;
				select.value = this.$refs.searchForm.dataset.regionDef;
				select.dispatchEvent(new Event('change'));
				pickerObj.rebuildPicker(this.$refs.regionEl);
			},
			updateMobSelects() {
				this.$nextTick(function () {
					let selectsToInit = document.querySelectorAll('.slp-form__select--mobile-init');
					selectsToInit.forEach(function(select){
						pickerObj.rebuildPicker(select);
					});
				});
			},
			updateLinks() {
				const query = new URLSearchParams(new FormData(this.$refs.searchForm)).toString();

				const moreLink = this.$refs.moreLink;
				moreLink.href = moreLink.href.substr(0, moreLink.href.indexOf('?')) + '?frompodbor2021=1&' + query;

				const mapLinks = document.querySelectorAll('.search-result-header__map, .h__sl-toolbar-item--map');
				if(mapLinks) {
					mapLinks.forEach(function(link) {
						link.href = link.href.substr(0, moreLink.href.indexOf('?')) + '?frompodbor2021=1&' + query;
					})
				}
			},
			handleResize() {
				this.mobile = window.innerWidth < 768;
				this.updateMobSelects();
			},
			changeType() {
				this.type = this.typeEl.options[this.typeEl.selectedIndex].dataset.type;
				this.updatePriceType();
			},
			changeRegion(e) {
				const select = e.target;
					
				this.regionId = select.value;

				// Расширенный поиск есть только для Спб, Мск, ЛО или МО то
				if (['1','2','3','4'].indexOf(this.regionId) != -1 ) {
					this.$refs.moreLink.style.display = '';
				} else {
					this.$refs.moreLink.style.display = 'none';
				}


			},
			updatePriceType() {
				this.$nextTick(function () {
					pickerObj.rebuildPicker(this.$refs.priceType);
					this.initPriceInput();
				});
			},
			toggleBigForm() {
				this.isBigFormActive = !this.isBigFormActive;
			}
		}
	}

	Vue.createApp(searchForm).mount(slpForm);
}